
export const data = [{
    "about":[
            {
            "abtone": "Hello! I'm Ebenezer, a passionate computer science student\
             with a burning curiosity for all things tech. Welcome to my digital space,\
              where I'm excited to share my journey, projects, and aspirations in the world\
               of computing.",    
            "abttwo": "My fascination with computers and technology began at a young age,\
             sparked by endless hours of tinkering with hardware and exploring\
              the depths of software. As I grew older, this passion evolved\
               into a relentless pursuit of knowledge in the field of \
               computer science. I embarked on this academic journey \
               with a thirst for understanding the intricacies of algorithms,\
                data structures, and the limitless potential of code.",
            "mainabout":"Currently pursuing a Bacholar's in Computer \
            Science at Springfield College, I've had the privilege of \
            learning from some of the brightest minds in the field. \
            My coursework has equipped me with a strong foundation \
            in various areas of computer science, including but not limited to",
            "techskills":[
                {
                    "sk": "~Soft Skills: Communication, Teamwork, Critical thinking, Adaptability, Leadership and Ownership"
                },
                {    
                    "sk":"~Programming Languages: Java, Python, C++, JavaScript and Kotlin."
                },
                {
                    "sk":"~Data Structures and Algorithms: Understanding and implementing data structures (e.g., arrays, linked lists, trees) and algorithms (e.g., sorting, searching) is crucial for efficient problem-solving."
                },
                {
                    "sk":"~Problem Solving: The ability to break down complex problems into manageable components and devise effective solutions is at the core of computer science"
                },
                {
                    "sk":"~Web Development: Knowledge of web technologies, including HTML, CSS, and JavaScript, is valuable for building web applications and user interfaces"
                },
                {
                    "sk":"~Version Control: Proficiency in version control systems like Git to manage code repositories and collaborate with teams"
                },
            ],    
            "proglangs":[
                {
                 "i":"Java"
                },
                {
                 "i":"C++"
                },
                {
                 "i":"Python"
                },
                {
                 "i":"Dart"
                },
                {
                 "i":"Kotlin1"
                },
                {
                 "i":"Html"
                },
                {
                 "i":"Css"
                },
                {
                 "i":"Kubernetes"
                },
                {
                 "i":"Docker"
                },
                {
                 "i":"React"
                },
                {
                 "i":"Tailwind"
                },
            ],    
            }
    ],
    "projects":[
        {
            "id": 1,
            "vidname": "linked.mp4",
            "protitle": "Bank App",
            "prodetails":"Fast is a banking application for everyone. It includes a presentable dasbboard which make navigation easily",
            "langused": [
               
                {
                 "name": "NextJs",
                },
                {
                 "name": "TailwindCss",
                },
                {
                 "name": "Sentry",
                },
                {
                 "name": "Appwriter",
                },
                {
                 "name": "Plaid",
                },
                {
                 "name": "Dwolla",
                },
            ],
            "prolink": "https://github.com/BroCode17/bank",
            "prolinkname":"Github",
            "site":"https://bank-two-iota.vercel.app",
            "video":"",
             "website":"Website",
             "show": false,
          },
        {
            "id": 2,
            "imgname": "nike.png",
            "protitle": "Nike Landing Page",
            "prodetails":"The landing page of the Nike website boasts a sleek and modern design, crafted with React components and styled using Tailwind CSS. \
            It features a dynamic hero section showcasing the latest Nike products, accompanied by eye-catching imagery and bold typography. Seamless navigation is facilitated through interactive and browsing experience.",
            "langused": [
               
                {
                 "name": "React + Vite",
                },
                {
                 "name": "Tailwindcss",
                },
            ],
            "prolink": "https://github.com/BroCode17/nike-landing-page/tree/main",
            "prolinkname":"Github",
            "site":"https://tailwindcssproj.com/",
            "video":"",
             "website":"Website",
             "show": false
          },
          {
            "id": 3,
            "imgname": "chatone.jpg",
            "protitle": "Peer-to-Peer Chatroom",
            "prodetails":"This is class based project which I developed to test my understanding in Database. The am was to implement a chatting which I can use to chat my friends in the class. Click on the card to watch a Demo",
            "langused": [
                {
                 "name": "Python",
                },
                {
                 "name": "Socket",
                },
                {
                 "name": "Colorama",
                },
                {
                 "name": "SQLite",
                },
            ],
            "prolink": "https://github.com/BroCode17/python-chatting-app/blob/main",
            "prolinkname":"Github",
            "video":"showwork",
            "show": true
          },
        {
            "id": 7,
            "imgname": "crud.jpg",
            "protitle": "SpringCRUD",
            "prodetails":"This app is built using the CRUD concept in CS. It obeys the MVC principle. Users can create, read, update, or delete a topic. Since this is a light app, an Inbuilt Array Data Structure is used for data storage instead of a Database. Click to watch a Demo.",
            "langused": [
               
                {
                 "name": "Java",
                },
                {
                 "name": "SpringBoot",
                },
            ],
            "prolink": "https://github.com/BroCode17/springboot-lesson-one/tree/master",
            "prolinkname":"Github",
            "video":"",
            "show": true
            
          },
        
        {
            "id": 5,
            "imgname": "hotelone.jpg",
            "protitle": "Hotel Management System",
            "prodetails":"Build with Hibernate, MySql, Java Swing, and SpringBoot. Functionalities consist of Admin Panel, User Panel, Booking Option, Printing Receipt, etc. Click to watch a Demo",
            "langused": [
                {
                 "name": "Java",
                },
                {
                 "name": "Spring",
                },
                {
                 "name": "Hebinate",
                },
                {
                 "name": "MySql",
                },
            ],
            "prolink": "https://github.com/BroCode17/hotel-management-system",
            "prolinkname":"Github",
            "video":"",
            "show": true
          },
        {
            "id": 6,
            "imgname": "air.jpeg",
            "protitle": "Flight Bookin App UI",
            "prodetails":"The UI consit of Home, Hotel, Profile, Search Screen and many more interesting Screens. Find out more by clicking on the card to watch a Demo",
            "langused": [
                {
                 "name": "Flutter",
                },
                {
                 "name": "Dart",
                },
                
            ],
            "prolink": "https://github.com/BroCode17/ticket_booking_app",
            "prolinkname":"Github",
            "video":"",
            "show": true
          },
        {
            "id": 4,
            "vidname": "flappybird.mp4",
            "protitle": "Flappy Bird",
            "prodetails":"Flappy Bird is a popular mobile game where players control a bird by press the space/arrowup key to make it flap its wings and navigate through pipes. The goal is to fly as far as possible without hitting any obstacles.",
            "langused": [
                {
                 "name": "HTML",
                },
                {
                 "name": "JavaScript",
                },
                {
                 "name": "Css",
                },
                
            ],
            "prolink": "https://github.com/BroCode17/flappy-bird-game",
            "prolinkname":"Github",
            "site":"https://brocode17.github.io/flappy-bird-game/",
            "video":"",
             "website":"Website",
             "show": false
          },
        
    ],
    "education":[
        {
            "date":"JAN - MAY 2024",
            "major":"BSc Computer Science",
            "university": "Springfield College",
            "location": "USA",
            "completion": "In Progress",
        },
        {
            "date":"JAN - DEC 2021",
            "major":"BSc Computer Science",
            "university": "Valley View University",
            "location": "Ghana",
            "completion": "Compeleted",
        }
    ],
    "experience":[
        {
            "date":"MAY - AUG 2022",
            "assign":"SD Intern",
            "comp":"Terra",
            "details": [
                {
                    "data": "~ Worked with a team of software developers to develop and maintain a web-based project management tool\
                    built in React, Redux, Nodejs and AWS for the company's clients. Participated in all phases of the software\
                    development life cycle, including requirements gathering, design, development, testing, and deployment"
                },
                {
                    "data": "~ Wrote clean, clear and well-tested code for various projects and collaborated effectively with members of the\
                    software development team and personnel in other departments\
                    "
                },
                
            ]
        },
        {
            "date":"SEP - DEC 2021",
            "assign":"IT Assistant",
            "comp":"Valley View University",
            "details": [
                {
                    "data": "~ Assisted in the maintenance and monitoring of network security protocols, ensuring data integrity and\
                    protecting against potential threats."
                },
                {
                    "data": "~ Actively contributed to departmental projects, such as system upgrades, fixing school servers, updating\
                    school websites while adhering to established guidelines and procedures."
                },     
            ]
        },
        {
            "date":"FEB22 - Present",
            "assign":"Academic Peer Tutor",
            "comp":"Springfield College",
            "details": [
                {
                    "data": "~ Tutoring students in computer science courses such as Data Structures and Algorithms,\
                    Object-Oriented Programming, and Web Development.\
                    "
                },
                {
                    "data": "~ Helping fellow students prepare for quizzes and examinations"
                },
                
            ]
        }
    ]
}]

